import {
  Category,
  Construction,
  Description,
  Person,
  WhereToVote,
} from '@mui/icons-material'

export const LkmMenuItems = [
  { Icon: Construction, link: '/orders', text: 'Мои монтажи' },
  { Icon: Category, link: '/product-types', text: 'Типы изделий' },
  { Icon: WhereToVote, link: '/regions', text: 'Регионы обслуживания' },
  { Icon: Description, link: '/documents', text: 'Сертификаты' },
  { Icon: Person, link: '/settings', text: 'Профиль' },
]
